import React from "react";

// Icônes SVG épurées pour MOVE — mêmes conventions que components/messages/icons.tsx (24×24,
// trait fin, monochrome, `currentColor` par défaut pour hériter la couleur du bouton/badge qui
// les entoure plutôt que d'imposer un hex figé).
interface IconProps { size?: number; color?: string }

export const RideIcon = ({ size = 20, color = "currentColor" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 17h2a1 1 0 0 0 1-1v-3c0-.9-.6-1.7-1.5-1.9L17 10s-1.3-1.4-2.2-2.3a2 2 0 0 0-1.4-.7H6c-.6 0-1.1.3-1.4.8L3 10.7A3.5 3.5 0 0 0 2 13v3c0 .6.4 1 1 1h2"/>
    <path d="M9 17h6"/>
    <circle cx="7" cy="17" r="2"/>
    <circle cx="17" cy="17" r="2"/>
  </svg>
);

export const BikeIcon = ({ size = 20, color = "currentColor" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5.5" cy="17.5" r="3.5"/>
    <circle cx="18.5" cy="17.5" r="3.5"/>
    <circle cx="15" cy="5" r="1.2" fill={color} stroke="none"/>
    <path d="M12 17.5V14l-3-3 4-3.2 2 3.2h3.5"/>
  </svg>
);

export const WalkIcon = ({ size = 20, color = "currentColor" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12.5" cy="4.2" r="1.4" fill={color} stroke="none"/>
    <path d="M9.5 20.5 11 14l-2.5-1.5.7-4L13 8l2 2.5-1 2.5 2.5 3-1.5 4.5"/>
    <path d="M6.5 7.5 11 9"/>
  </svg>
);

export const ScootIcon = ({ size = 20, color = "currentColor" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="19" r="2"/>
    <circle cx="16.5" cy="19" r="2"/>
    <path d="M7 19h7l1.5-11.5H18"/>
    <path d="M12.5 7.5H18"/>
  </svg>
);

export const MOVE_MODE_ICONS = { ride: RideIcon, bike: BikeIcon, walk: WalkIcon, scoot: ScootIcon } as const;
export type MoveMode = keyof typeof MOVE_MODE_ICONS;
